import { jsx as r, Fragment as t, jsxs as o } from "react/jsx-runtime";
import s from "../BusRental.context.js";
import i from "../Widget/BusRentalWidget.js";
import m from "../components/ReservationRequest/ReservationRequest.js";
const n = (e) => /* @__PURE__ */ r(t, { children: /* @__PURE__ */ o(s, { ...e, children: [
  /* @__PURE__ */ r(i, {}),
  /* @__PURE__ */ r(m, {})
] }) }), l = n;
export {
  l as default
};
